module.exports = __webpack_public_path__ + "static/media/Pedro Nobre Headshot_1678716236124.de799900.png";